import React from 'react'

export const newYorkSetupVars = {
  siteId: 'new_york',
  pathPrefix: '/ny',
  menuHeader: "Discover New York's Solution for:",
  appUrl: 'https://ny.headed2.com',
  logoImg: '/images/assets/new_york/horizontal/dark.svg',
  headerTitle: `The New York CareerExplorer is a system designed for New York`
}
